export default {
  data() {
    return {
      isLoading: true,
      switch_pinyin:false,
      canChangeBirthday:false,
      id_type:'',
      spell_family:false,// 有姓 无名
      spell_both:false,// 都有
      spell_none:false,// 都没有
      auditData:[],
      not_allow_change:true,
      info_status:"",
      memberType:'',
      option: {
        disabledDate: time => {
          return (
              new Date(time).getTime()  > new Date().getTime() - 86400000
          );
        }
      },
      noEdit: {
        gender: "", // 性别
        phone: "", // 手机号
        idNum: "", // 身份证号
        birthDay: "", // 出生日期
        org_abbreviation: "", // 出生日期
      },
      vitaForm: {
        name: "", // 姓名
        family_name_spell: "", // 姓氏
        given_name_spell: "", // 名字
        gender: "", // 性别
        coach_experience: "", // 不要了
        coach_experience_not: "", // 不要了
        take_place: "",
        sport_experience: "",
        id_card_photo_front: "", // 身份证照片正面，（一个URL）
        id_card_photo_verso: "", // 身份证照片背面，（一个URL）
        profile_picture: "", // 个人头像，（一个URL）
        email_address: "", // 邮箱地址
        nationality: "", // 国籍
        nation: "", // 民族
        former_name: "", // 曾用名
        passport: "", // 护照号
        // date_of_birth: "", // 出生日期，时间戳
        medical_history: "", // 伤病历史
        height: "", // 身高，（cm）应该为纯数字
        weight: "", // 体重，（kg）保留一位小数
        contact_address: "", // 个人通信地址
        contact_numbers: "", // 个人联系电话，可以是座机、手机
        postcode: "", // 个人邮编
        fax_personage: "", // 个人传真
        club_name: "", // 俱乐部名称
        club_address: "", // 俱乐部地址
        club_postcode: "", // 俱乐部邮编
        club_email: "", // 俱乐部邮箱（需要验证格式）
        club_fax: "", // 俱乐部传真
        club_website: "", // 俱乐部网址
        club_telephone: "", // 俱乐部电话，可以是座机、手机
        track_suit: "", // 套服尺码
        polo_T: "", // T恤尺码
        shorts: "", // 短裤尺码
        track_shoes: "", // 跑步鞋号
        english_ability: "", // 英语能力
        english_ability_number: "", // 英语能力编号
        english_file: "", // 英语能力文件
        english_file_list: [], // 英语能力文件
        take_unit:"",// 执教单位
        team_age:"",// 队伍年龄
        team_sex:"",// 队伍性别
        take_job:"",// 职务
        take_unit_name:"",// 单位名称
        sport_experience_new:"",// 运动经历-算分用的
        is_goalkeeper:"",// 是否守门员
        highest_experience_record:"",// 最高正式比赛出场次数
        // 外语
        language_row: [
          {
            language_ids: "",
            spoken: "",
            written: "",
          }
        ],
        // 教育经历
        academic_qualification: [
          {
            time: [],
            academic_start_date: "", // 开始日期
            academic_end_date: "", // 结束日期
            academic_address: "", // 地点
            academic_venue: "", // 学校
            qualification: "", // 学历
            references_man: "", // 证明人
            contact_details: "", // 联系电话
            academic_number: "", // 学历证书编号
            is_football: "", // 是否足球专项
            work_certificate: "", // 工作证明
            work_certificate_list: [], // 工作证明
            zhijin:"N"
          },
        ],
        // 培训历程
        /*coaching_qualification: [
          {
            time: [],
            train_start_date: "", // 开始日期
            train_end_date: "", // 结束日期
            train_address: "", // 培训地点
            train_certificate: "", // 培训等级
            certificate_number: "", // 证书编号
            train_references: "", // 主讲师
            train_contact_details: "", // 联系电话
          }
        ],*/
        // 执教经历
        coaching_Experience: [
          {
            time: [],
            coach_start_date: "", // 开始日期
            coach_end_date: "", // 结束日期
            coach_address: "", // 执教地点
            coach_position: "", // 职务
            coach_team: "", // 执教球队
            team_level:"",// 球队级别
            coach_references: "", // 证明人
            coach_contact_details: "", // 联系电话
            coach_achievements:"", //主要成绩
            work_certificate: "", // 工作证明
            work_certificate_list: [], // 工作证明
            zhijin:"N"
          }
        ],
        // 新增 其他工作经历
        coaching_Experience_not: [
          {
            coach_start_date: "", // 开始日期
            coach_end_date: "", // 结束日期
            coach_address: "", // 执教地点
            coach_position: "", // 职务
            coach_references: "", // 证明人
            references_position: "", // 证明人职务
            coach_contact_details: "", // 联系方式
            coach_achievements: "", // 主要经历
            work_certificate: "", // 工作证明
            work_certificate_list: [], // 工作证明
            zhijin:"N"
          }
        ],
        // 运动经历
        playing_experience: [
          {
            time: [],
            play_start_date: "", // 开始日期
            play_end_date: "", // 结束日期
            play_address: "", // 地点
            play_team: "", // 所在球队
            play_team_level: "", // 球队级别
            play_references: "", // 主教练
            play_contact_details: "", // 联系电话
            play_achievements:"", //主要成绩
            zhijin:"N"
          }
        ],
      },
    };
  },
};
